import { useState, useCallback } from 'react';
import { Property, AppUser } from '../types';
import { getAllActivePropertiesApi } from '../services/adminPropertyApiClient';

export const useInventoryStats = (appUser: AppUser | null) => {
  const [allProperties, setAllProperties] = useState<Property[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAllActiveProperties = useCallback(async () => {
    if (!appUser) return;
    setIsLoading(true);
    setError(null);
    try {
      const active = await getAllActivePropertiesApi();
      setAllProperties(active);
    } catch (err: any) {
      console.error("Error fetching inventory stats:", err);
      setError("Error al cargar el inventario completo.");
    } finally {
      setIsLoading(false);
    }
  }, [appUser]);

  return { allProperties, isLoading, error, fetchAllActiveProperties };
};
